import { Outlet } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userRoleAtom } from "../../store";
import { Unauthorized } from "../../pages";

interface ProtectedRouteProps {
  allowedRoles: string[];
}

export const ProtectedRoute = ({ allowedRoles }: ProtectedRouteProps) => {
  const userRole = useRecoilValue(userRoleAtom) ?? "user";

  // If the user doesn't have permission, show the Unauthorized page
  if (!userRole || !allowedRoles.includes(userRole)) {
    return <Unauthorized />;
  }

  return <Outlet />;
};
